import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../app/app.reducer';
import { ReservasProvider } from '../../providers/reservas/reservas';
import { UtilsProvider } from '../../providers/utils/utils';

@Component({
  selector: 'calendar',
  templateUrl: 'calendar.html',
  providers: [ReservasProvider]
})
export class CalendarComponent implements OnInit  {
  @Input() listaSeguimientoReserva:any =[];
  months: string[] = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
  calendarData: { month: string, days: Date[] }[] = [];
  currentMonthIndex: number = 0;
  weekdays: string[] = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
  @Input() listaCalendar:any = [];
  @Input() datosServiceCalendar:any=[];
  @Input() buscarLista: (event: any) => void; // Recibe la función como un @Input
  endDate = new Date('2034-12-31');
  @Input() cambiarFecha:any=[];
  selectedDayIndex: number | null = null;
  @Output() fechaSeleccionada = new EventEmitter<any>();
  selectedHour: string = "";
  isTime: boolean = false;
  ayudaCalendar="Para que las fecha queden registradas debe seleccionar el botón 'Fecha inicio' y/o 'Fecha fin' antes de interactuar con el calendario";
  constructor(  private store: Store<AppState>, public reservasProvider: ReservasProvider,
    public utilsMensajero:UtilsProvider,
  ) {
    const currentDate = new Date(); // obtener la fecha actual
    this.generateCalendar(currentDate);
  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes && changes.listaSeguimientoReserva && changes.listaSeguimientoReserva.currentValue) {
      const newValue = changes.listaSeguimientoReserva.currentValue;

      if (newValue.fechaInicio) {
        const currentDate = new Date(newValue.fechaInicio); // Obtener la fecha actual del nuevo valor
        this.generateCalendar(currentDate);
      }
    }
    if (changes && changes.cambiarFecha && changes.cambiarFecha.currentValue) {
      const newValue = changes.cambiarFecha.currentValue;
      if (newValue) {
        this.validarFechaSeleccion(newValue);
      }
    }
  }

  ngOnInit() {
  }

  ngOnDestroy() {
  }

  manejarDatosCalendar(event: string) {
  }

  generateCalendar(currentDate: Date) {
    const startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1); // establecer la fecha de inicio al primer día del mes actual

    let currentMonth = startDate.getMonth();

    let currentDays = []; // Inicializar una matriz temporal para los días
    this.obtenerDiaDelMesEnLetras(startDate);

    while (startDate <= this.endDate) {
      const currentDate = new Date(startDate);
      const monthIndex = currentDate.getMonth();

      if (monthIndex !== currentMonth) {
        this.calendarData.push({ month: this.months[currentMonth], days: [...currentDays] }); // Usar una copia de currentDays
        currentMonth = monthIndex;
        currentDays = []; // Reinicializar la matriz temporal para los días
      }
      currentDays.push(new Date(currentDate));
      startDate.setDate(startDate.getDate() + 1);
    }
    if (currentDays.length > 0) {
      this.calendarData.push({ month: this.months[currentMonth], days: [...currentDays] }); // Usar una copia de currentDays
    }

  }
  isToday(date: Date): boolean {
    const today = new Date();
    return date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear();
  }
  showNextMonth() {
    if (this.currentMonthIndex < this.calendarData.length - 1) {
      this.currentMonthIndex++;
      const nextMonthDate = new Date(new Date().getFullYear(), this.currentMonthIndex + 1, 1);
      this.generateCalendar(nextMonthDate);
    }
  }

  showPreviousMonth() {
    if (this.currentMonthIndex > 0) {
      this.currentMonthIndex = 0;
      const currentDate = new Date();
      this.generateCalendar(currentDate);
    }
  }

  showPreviousMonthOld() {
    if (this.currentMonthIndex > 0) {
      this.currentMonthIndex--;
      this.generateCalendar(new Date(new Date().getFullYear(), this.currentMonthIndex - 1, 1))
      this.obtenerDiaDelMesEnLetras(new Date(new Date().getFullYear(), this.currentMonthIndex - 1, 1));
    }
  }
  obtenerDiaDelMesEnLetras(startDate: Date) {
    const daysOfWeek = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    const firstDayOfMonthIndex = startDate.getDay(); // Obtener el índice del primer día del mes
    const reorderedDaysOfWeek = [
      ...daysOfWeek.slice(firstDayOfMonthIndex),
      ...daysOfWeek.slice(0, firstDayOfMonthIndex)
    ];
    this.weekdays = reorderedDaysOfWeek;
  }

  isStartDateOrEndDate(date: Date) {
    const defaultColor = '#006400'; // Color por defecto
    if (this.listaSeguimientoReserva.length > 0) {
      const dateISO = date.toISOString().slice(0, 10); // Obtener la fecha ISO sin la hora
      let isInEvent = false; // Variable para controlar si el día está en un evento
      for (const evento of this.listaSeguimientoReserva) {
        const startDate = new Date(evento.fechaInicio).toISOString().slice(0, 10);
        const endDate = evento.fechaFin ? new Date(evento.fechaFin).toISOString().slice(0, 10) : startDate; // Comprobar si fechaFin está definida
        if (dateISO >= startDate && dateISO <= endDate) {
          if (!isInEvent) {
            isInEvent = true;
            return evento.color;
          } else {
            return defaultColor;
          }
        }
      }
      return defaultColor; // Utilizar el color por defecto si el día no corresponde a ningún evento
    }
    return defaultColor; // Utilizar el color por defecto si la lista está vacía
  }

  isStartDateOrEndDateAll(date: Date | string): string {
    // Asegúrate de que 'date' sea un objeto Date válido
    if (!(date instanceof Date) || isNaN(date.getTime())) {
      return ''; // Retorna un string vacío si la fecha es inválida
    }

    if (this.calendarData[this.currentMonthIndex].days.length > 0) {
      const dateISO = date.toISOString().slice(0, 10); // Obtener la fecha ISO sin la hora
      for (const evento of this.calendarData[this.currentMonthIndex].days) {
        const startDate = new Date(evento).toISOString().slice(0, 10);
        if (dateISO === startDate) {
          return "#083472"; // Retorna el color si encuentra una coincidencia
        }
      }
    }
    return ''; // Retorna un string vacío si no hay coincidencias
  }

  isDayInRange(dateUTC: number, startUTC: number, endUTC: number): boolean {
    return dateUTC >= startUTC && dateUTC <= endUTC; // Comprobar si la fecha está dentro del rango establecido, incluyendo el día de inicio
  }



  async updateFecha(day: any, index: number) {
    let valoresTurno: any = await this.buscarTurnosStore();
    if(valoresTurno !== undefined &&
      valoresTurno.fechaInicio !== null &&
      valoresTurno.fechaFin !== null &&
      valoresTurno.turnos.productosElaboradosId !== null &&
      valoresTurno.turnos.companiasId !== null){
        let companiasId = valoresTurno.turnos.companiasId
        let id = valoresTurno.turnos.productosElaboradosId
        let tipo = valoresTurno.turnos.mesasId === 0 ? 'P': 'M'
        let turno = valoresTurno.turnos.turno
        this.reservasProvider.buscarSeguimientoReservasDiaAsignado(companiasId,id,tipo,turno,'N').subscribe( (items: any) => {
          let valoresTurnos = JSON.parse(items['_body'])
          let valoresNuevoTurno = valoresTurnos.data[0]
          console.log(valoresNuevoTurno)

          let esValido: boolean = true; // Inicializar la variable de validación
          let turno = 0
          for (let item of valoresNuevoTurno) {
            let fechaInicio: Date = new Date(item.fechaInicio);
            let fechaFin: Date = new Date(item.fechaFin);

            // Extraer solo la parte de la fecha (sin la hora) de day, fechaInicio y fechaFin
            let dayFecha = new Date(day.getFullYear(), day.getMonth(), day.getDate());
            let fechaInicioFecha = new Date(fechaInicio.getFullYear(), fechaInicio.getMonth(), fechaInicio.getDate());
            let fechaFinFecha = new Date(fechaFin.getFullYear(), fechaFin.getMonth(), fechaFin.getDate());

            if (dayFecha >= fechaInicioFecha && dayFecha <= fechaFinFecha) {
                turno = item.turno;
                esValido = false; // Si la variable day está entre alguna de las fechas, marcar como inválido
                break; // Salir del bucle, ya que la condición se cumplió
            }
        }
          if(esValido) {
            console.log(esValido);
            this.fechaSeleccionada.emit({ day: day, index: index });
            this.isTime=true;
          } else {
            this.isTime=false;
            this.utilsMensajero.mensajeMuestro('Warning','La fecha seleccionada ya esta reservada para el turno: ' + turno,'warning')
            return
          }
          }, (error) => {
          this.isTime=false;
          console.log(error);
        })

      } else {
        this.isTime=false;
        this.utilsMensajero.mensajeMuestro('Advertencia','Faltan datos para poder guardar el registro','Advertencia')
        return
      }
  }

  validarFechaSeleccion(fecha: any) {
    const currentDate = new Date(fecha.day); // Obtener la fecha actual del nuevo valor
    this.isStartDateOrEndDateAll(currentDate);
  }

  selectHour(selectedHour: string, day: any, index: number) {
    this.selectedHour = selectedHour;
    this.isTime=false;
    if (selectedHour) {
        this.selectedHour = selectedHour;
        const [hour, minutes] = selectedHour.split(':');
    const selectedHourInMilliseconds = (parseInt(hour) * 60 + parseInt(minutes) ) * 60 * 1000;

    // Crear nueva fecha con la hora actualizada
    const fechaActualizada = new Date(day.getTime() + selectedHourInMilliseconds);
    this.updateFecha(fechaActualizada, index);
    this.isTime=false;
    }

}

async buscarTurnosStore() {
  return new Promise((resolve, reject) => {
     this.store.select('turnos').subscribe((turnos) => {
      return resolve(turnos)
     })
   });
 }

}



// WEBPACK FOOTER //
// ./src/components/calendar/calendar.ts